import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import './PaymentModal.scss';

function SuccessPayment() {
  const { t } = useTranslation();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const reference = query.get('TransactionReference');
  const amount = query.get('Amount');
  const status = query.get('Status');
  const statusMessage = query.get('StatusMessage');

  return (
    <div className="payment-modal">
      <div className="payment-modal__title">{ t('depositFunds.success') }</div>
      <div className="payment-modal__transaction-infos">
        {
          reference && <div className="payment-modal__info">
            <span className="payment-modal__info-title">{ t('depositFunds.reference') }:</span>
            <span>{ reference }</span>
          </div>
        }
        {
          amount && <div className="payment-modal__info">
            <span className="payment-modal__info-title">{ t('depositFunds.amount') }:</span>
            <span>{ amount }</span>
          </div>
        }
        {
          status && <div className="payment-modal__info">
            <span className="payment-modal__info-title">{ t('depositFunds.status') }:</span>
            <span>{ status }</span>
          </div>
        }
        {
          statusMessage && <div className="payment-modal__info">
            <span className="payment-modal__info-title">{ t('depositFunds.statusMessage') }:</span>
            <span>{ statusMessage }</span>
          </div>
        }
      </div>
      <div className="payment-modal__text">{ t('depositFunds.successMessage') } </div>
    </div>
  );
}

export default SuccessPayment;
